/// <reference path="../../adpIntegration/sections/adpIntegration.main.section.ts" />

module Meevo.Plugins.AdpWiselyIntegration {
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class WiselyMainSection extends Meevo.Plugins.AdpIntegration.MainSection {

        protected localLocationCode = '';

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            modalService: Meevo.Components.Modal.IModalService,
            busyService: Meevo.Components.Busy.IBusyService,
            sectionSecurityKey?: string
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                noun,
                identityService,
                modalService,
                busyService,
                sectionSecurityKey);

            this.integrationStage = 1;
        }

        private integrationStage: number;

        rollbackChanges(): void {
            super.rollbackChanges();

            if (!_.isUndefined(this.model.adpLocationCode))
                this.localLocationCode = this.model.adpLocationCode;
            else
                this.localLocationCode = '';

            this.integrationStage = 1;
        }

        activate(): void {

            super.activate();

            if (this.localLocationCode.length == 0 && !_.isUndefined(this.model.adpLocationCode))
                this.localLocationCode = this.model.adpLocationCode;

            if (this.readyForLocationCodeSetupProcess() && this.needLocationCodeSetupProcess() && this.model.locationCodeList.length == 0)
                this.modalService.warning("WISELY_EMPTY_LOCATIONCODE_LIST");

            if (this.readyForFundingAccountSetupProcess() && this.needFundingAccountSetupProcess() && this.model.fundingAccountList.length == 0)
                this.modalService.warning("WISELY_EMPTY_FUNDINGACCOUNTS_LIST");

            this.defaultFundingAccount();
        }

        needConnectorIdSetupProcess(): boolean {
            return _.isUndefined(this.model.connectorId) || this.model.connectorId == '';
        }

        readyForLocationCodeSetupProcess(): boolean {
            return this.model.consentCompleted && this.needLocationCodeSetupProcess() && !this.needConnectorIdSetupProcess();
        }

        readyForFundingAccountSetupProcess(): boolean {
            return this.model.consentCompleted && !this.needConnectorIdSetupProcess() && this.localLocationCode.length > 0;
        }

        needLocationCodeSetupProcess(): boolean {
            return _.isUndefined(this.model.adpLocationCode) || this.model.adpLocationCode == '';
        }

        needFundingAccountSetupProcess(): boolean {
            return _.isUndefined(this.model.wiselyFundingAccountNumber) || this.model.wiselyFundingAccountNumber == '';
        }

        CanChangeIntegrationStatus(): boolean {
            return this.model.isAdpMarketplaceSubscriptionActive &&
                this.model.consentCompleted && this.model.canEnableStatus &&
                this.localLocationCode.length > 0 &&
                !this.needFundingAccountSetupProcess();
        }

        preSave(): any {
            if (_.isUndefined(this.model.adpLocationCode) && this.localLocationCode.length > 0)
                this.model.adpLocationCode = this.localLocationCode;

            return super.preSave();
        }

        defaultFundingAccount(): void {
            if (this.needFundingAccountSetupProcess() && Model.Guard.isSomething(this.model.fundingAccountList) && this.model.fundingAccountList.length == 1) {
                this.model.wiselyFundingAccountNumber = this.model.fundingAccountList[0].financialAccount.accountNumber;
            }
        }

        refreshFundingAccountList(): void {
            this.busyService.start();
            this.dataService.getSection("AdpWiselyIntegration", `${this.model.connectorId}/${this.localLocationCode}/WiselyFundingAccounts`).then((data: any) => {
                if (data) {
                    this.model.fundingAccountList = data;
                    this.defaultFundingAccount();
                }
            }).finally(() => { this.busyService.stop(); });
        }
    }

}